/**
 * BundleBuilder-local RHF fork of CommonFields/DesignReviewPage.tsx (shared
 * across bundle types — not editable in place).
 */
import FormSubSection from "../../CommonFields/FormSubSection";
import { FontStyles } from "../../constants";
import { FormColorPicker, FormInputWithUnit, FormSelect, FormRangeSlider } from "../../../../components/FormFields";
import styles from "../../CommonFields/CommonFields.module.css";

const DesignReviewPage = () => {
    return (
        <div>
            <div id="review-bundle-title">
                <FormSubSection rowLabel="Bundle Title">
                    <FormColorPicker name="bundles_design.bundle_title_color" label="Text Color" />
                    <FormInputWithUnit
                        name="bundles_design.bundle_title_size"
                        min={0}
                        label="Size"
                        placeholder="font size"
                        unitSuffix="px"
                    />
                    <FormSelect
                        name="bundles_design.bundle_title_style"
                        label="Style"
                        options={FontStyles}
                        placeholder="Font style"
                    />
                </FormSubSection>
            </div>

            <div id="review-order-summary">
                <FormSubSection rowLabel="Order Summary Card">
                    <FormColorPicker name="bundles_design.order_summary_bg_color" label="Background Color" />
                </FormSubSection>
            </div>

            <div id="review-order-summary-header">
                <FormSubSection rowLabel="Order Summary Header and Total">
                    <FormColorPicker name="bundles_design.order_summary_header_text_color" label="Headers Text Color" />
                    <FormInputWithUnit
                        name="bundles_design.order_summary_header_text_size"
                        min={0}
                        label="Size"
                        placeholder="font size"
                        unitSuffix="px"
                    />
                    <FormSelect
                        name="bundles_design.order_summary_header_text_style"
                        label="Style"
                        options={FontStyles}
                        placeholder="Font style"
                    />
                </FormSubSection>
            </div>

            <div id="review-order-summary-rows">
                <FormSubSection rowLabel="Order Summary Rows">
                    <FormColorPicker name="bundles_design.order_summary_rows_text_color" label="Rows Text Color" />
                    <FormInputWithUnit
                        name="bundles_design.order_summary_rows_text_size"
                        min={0}
                        label="Size"
                        placeholder="font size"
                        unitSuffix="px"
                    />
                    <FormSelect
                        name="bundles_design.order_summary_rows_text_style"
                        label="Style"
                        options={FontStyles}
                        placeholder="Font style"
                    />
                </FormSubSection>
            </div>

            <div id="review-edit-bundle-cta">
                <FormSubSection rowLabel="Edit Bundle CTA">
                    <FormColorPicker name="bundles_design.edit_bundle_cta_bg_color" label="Background Color" />
                    <FormColorPicker name="bundles_design.edit_bundle_cta_text_color" label="Text Color" />
                </FormSubSection>
            </div>

            <div id="review-product-card">
                <FormSubSection rowLabel="Review Product Card" hideSeparator>
                    <FormColorPicker name="bundles_design.review_product_border_color" label="Product Border Color" />
                    <FormInputWithUnit
                        name="bundles_design.review_product_border_width"
                        min={0}
                        label="Product Border Width"
                        placeholder="font size"
                        unitSuffix="px"
                    />
                    <FormRangeSlider
                        name="bundles_design.review_product_border_radius"
                        min={0}
                        max={100}
                        label="Product Border Radius"
                        suffixTemplate={(val) => `${val}px`}
                        wrapperClassName={styles.rangeSliderOverride}
                    />
                    <FormColorPicker name="bundles_design.review_product_img_border_color" label="Image Border Color" />
                    <FormInputWithUnit
                        name="bundles_design.review_product_img_border_width"
                        min={0}
                        label="Image Border Width"
                        placeholder="font size"
                        unitSuffix="px"
                    />
                    <FormRangeSlider
                        name="bundles_design.review_product_img_border_radius"
                        min={0}
                        max={100}
                        label="Image Border Radius"
                        suffixTemplate={(val) => `${val}px`}
                        wrapperClassName={styles.rangeSliderOverride}
                    />
                </FormSubSection>
            </div>

            <div id="add-on-products">
                <FormSubSection rowLabel="Add-on Products" hideSeparator>
                    <FormColorPicker name="bundles_design.addon_title_text_color" label="Title Text Color" />
                    <FormInputWithUnit
                        name="bundles_design.addon_title_text_size"
                        min={0}
                        label="Title Text Size"
                        placeholder="text size"
                        unitSuffix="px"
                    />
                    <FormColorPicker name="bundles_design.addon_card_bg_color" label="Card Background Color" />
                </FormSubSection>
            </div>
        </div>
    );
};

export default DesignReviewPage;
